export function getParams (state){
    return state.params
}

export function parameters(state) {
   return 'ok'
}
